import { render, staticRenderFns } from "./UserProfileDrawer.vue?vue&type=template&id=279cd5a7&scoped=true"
import script from "./UserProfileDrawer.vue?vue&type=script&lang=js"
export * from "./UserProfileDrawer.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "279cd5a7",
  null
  
)

export default component.exports